document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper === 'undefined') {
        return;
    }
    var wideOpts = {
        slidesPerView: 1.5,
        spaceBetween: 15,
        breakpoints: {
            992: {
                slidesPerView: 2,
                spaceBetween: 30
            }
        }
    };
    var stripOpts = {
        slidesPerView: 2.5,
        spaceBetween: 15,
        breakpoints: {
            992: {
                slidesPerView: 4,
                spaceBetween: 30
            }
        }
    };
    document.querySelectorAll('.collection-all .swiper-collection').forEach(function (el) {
        new Swiper(el, wideOpts);
    });
    document.querySelectorAll('.collection-all .swiper-limited').forEach(function (el) {
        new Swiper(el, stripOpts);
    });
    document.querySelectorAll('.collection-all .swiper-exclusive').forEach(function (el) {
        new Swiper(el, stripOpts);
    });
});
